// The three kinds of doctor calendar event, and how each one looks.
//
// Gold for a surgery, sage for the rest — deliberately NOT the teal an
// appointment wears, so one glance separates "a patient is coming" from "the
// doctor is busy". Colours are the brand palette (doc/branding-rule.html):
// gold accent #D7A05C and the desaturated sage neutrals #9DB3B1 / #C7D6D5.
//
// Its own module rather than a second export from the modal, because both the
// modal and the calendar page read it and a component file that also exports
// constants breaks React fast refresh.

export const EVENT_TYPES = ['surgery', 'meeting', 'other'];

export const EVENT_TYPE_STYLES = {
    surgery: { bg: '#D7A05C', fg: '#FFFFFF' },
    meeting: { bg: '#9DB3B1', fg: '#12312F' },
    other: { bg: '#C7D6D5', fg: '#12312F' },
};
